import React, { useState } from "react";
import EventCard from "./EventCard";
import WeekStrip from "./WeekStrip";
import InboxBar from "./InboxBar";

const DAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const GAP_DATES = new Set(["2026-04-25", "2026-05-02", "2026-05-09"]);
const WARN_DATES = new Set(["2026-04-28", "2026-05-05"]);

function buildSampleDays(startDate, count) {
  const days = [];
  const today = startDate.toISOString().slice(0, 10);
  for (let i = 0; i < count; i++) {
    const d = new Date(startDate);
    d.setDate(startDate.getDate() + i);
    const date = d.toISOString().slice(0, 10);
    let status = "covered";
    if (date === today) status = "today";
    else if (GAP_DATES.has(date)) status = "has-gap";
    else if (WARN_DATES.has(date)) status = "has-warn";
    days.push({
      date,
      dayLabel: DAY_LABELS[d.getDay()],
      dayNum: d.getDate(),
      status,
    });
  }
  return days;
}

const SAMPLE_DAYS = buildSampleDays(new Date("2026-04-23"), 21);

const VARIANTS = [
  {
    status: "covered",
    time: "9:00 AM — 12:00 PM",
    title: "Spring Break Camp",
    meta: ["Ages 7–12", "Full Facility"],
    staff: [
      { id: "1", name: "Jack", role: "manager" },
      { id: "2", name: "Danny R.", role: "head" },
      { id: "3", name: "Sam L.", role: "assistant" },
    ],
  },
  {
    status: "missing-head",
    flagLabel: "No Head",
    time: "4:00 — 5:00 PM",
    title: "Soccer Class",
    meta: ["Ages 6–8", "Field 2"],
    staff: [
      { id: "4", name: "Ryan K.", role: "assistant" },
      { id: "5", name: "Maya P.", role: "assistant" },
    ],
  },
  {
    status: "double-head",
    flagLabel: "2 Heads",
    time: "11:00 AM — 12:30 PM",
    title: "Birthday Party",
    meta: ["Ages 5–7", "Field 3"],
    staff: [
      { id: "6", name: "Tyler M.", role: "head" },
      { id: "7", name: "Jordan F.", role: "head" },
    ],
  },
  {
    status: "unassigned",
    flagLabel: "Unassigned",
    time: "5:00 — 6:00 PM",
    title: "Flag Football",
    meta: ["Ages 9–11", "Field 1"],
    staff: [],
  },
];

export default function EventCardPreview() {
  const [selectedDate, setSelectedDate] = useState(null);

  function handleSelectDay(date) {
    setSelectedDate(date);
    console.log("[WeekStrip] selected:", date);
  }

  return (
    <div className="min-h-screen bg-[#F5F5F5] flex items-start justify-center py-10 px-4">
      <div className="w-full max-w-[420px] flex flex-col gap-4">
        {/* InboxBar preview */}
        <div className="bg-white rounded-2xl shadow-sm p-5">
          <div className="font-sans font-bold text-[13px] uppercase tracking-widest text-[#6B6B6B] mb-4">
            InboxBar Preview
          </div>
          <div className="flex flex-col gap-3">
            <InboxBar
              swaps={1}
              covers={2}
              timeoff={1}
              onClick={() => console.log("[InboxBar] urgent tapped")}
            />
            <InboxBar
              swaps={0}
              covers={0}
              timeoff={1}
              onClick={() => console.log("[InboxBar] default tapped")}
            />
          </div>
        </div>

        {/* WeekStrip preview */}
        <div className="bg-white rounded-2xl shadow-sm p-5">
          <div className="font-sans font-bold text-[13px] uppercase tracking-widest text-[#6B6B6B] mb-4">
            WeekStrip Preview
          </div>
          <WeekStrip
            days={SAMPLE_DAYS}
            selectedDate={selectedDate}
            onSelectDay={handleSelectDay}
          />
          {selectedDate && (
            <div className="mt-3 text-[11px] font-mono text-[#6B6B6B]">
              selected: {selectedDate}
            </div>
          )}
        </div>

        {/* EventCard preview */}
        <div className="bg-white rounded-2xl shadow-sm p-5">
          <div className="font-sans font-bold text-[13px] uppercase tracking-widest text-[#6B6B6B] mb-5">
            EventCard Preview — All Variants
          </div>
          <div className="flex flex-col gap-4">
            {VARIANTS.map((v) => (
              <EventCard
                key={v.status}
                status={v.status}
                flagLabel={v.flagLabel}
                time={v.time}
                title={v.title}
                meta={v.meta}
                staff={v.staff}
                onClick={() => alert(`Tapped: ${v.title}`)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
